export const SOURCING_EVENT_LIST_SEARCH = 'SOURCING_EVENT_LIST_SEARCH'
export const SOURCING_EVENT_LIST_EVENTS = 'SOURCING_EVENT_LIST_EVENTS'
export const SOURCING_EVENT_LIST_ALL_STATUS = 'SOURCING_EVENT_LIST_ALL_STATUS'
export const SOURCING_EVENT_LIST_ALL_SEAL_STATUS =
  'SOURCING_EVENT_LIST_ALL_SEAL_STATUS'
export const SOURCING_EVENT_LIST_ALL_AWARD = 'SOURCING_EVENT_LIST_ALL_AWARD'
export const SOURCING_EVENT_LIST_ALL_USER = 'SOURCING_EVENT_LIST_ALL_USER'
export const SOURCING_EVENT_LIST_LOAD = 'SOURCING_EVENT_LIST_LOAD'
export const SOURCING_EVENT_LIST_ERROR = 'SOURCING_EVENT_LIST_ERROR'
export const SOURCING_EVENT_LIST_SUCCEED = 'SOURCING_EVENT_LIST_SUCCEED'
